import { render } from "./imager.vue?vue&type=template&id=0a3db189&scoped=true"
import script from "./imager.vue?vue&type=script&lang=js"
export * from "./imager.vue?vue&type=script&lang=js"

import "./imager.vue?vue&type=style&index=0&id=0a3db189&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a3db189"]])

export default __exports__